import { createBrowserRouter, Navigate } from 'react-router-dom';
import { App } from './App';
import { ProtectedRoute } from '@/app/ProtectedRoute';
import { LoginPage } from '@/pages/LoginPage/LoginPage';
import { ThematicPage } from '@/pages/ThematicPage/ThematicPage';
import { EconomicSectorPage } from '@/pages/EconomicSectorPage/EconomicSectorPage';
import { GrammaticalReferencePage } from '@/pages/GrammaticalReferencePage/GrammaticalReferencePage';
import { HistoryPage } from '@/pages/HistoryPage/HistoryPage';
import { NotFoundPage } from '@/pages/NotFoundPage/NotFoundPage';

export const router = createBrowserRouter(
  [
    {
      path: '/login',
      element: <LoginPage />,
    },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="/thematic" replace />,
        },
        {
          path: 'thematic',
          element: <ThematicPage />,
        },
        {
          path: 'economic-sector',
          element: <EconomicSectorPage />,
        },
        {
          path: 'grammatical-reference',
          element: <GrammaticalReferencePage />,
        },
        {
          path: 'history',
          element: <HistoryPage />,
        },
        {
          path: '*',
          element: <NotFoundPage />,
        },
      ],
    },
  ],
  {
    basename: '/ui',
  }
);
